// https://vuex.vuejs.org/en/getters.html
export default {
  // userMail (state) {
  //   return state.mail
  // }
  project(state) {
    return state.project;
  },
  subProject(state) {
    return state.subProject;
  },
  CEReports(state) {
    return state.CEReports;
  },
  Data2(state) {
    return state.Data2;
  },
  proDevices() {
    // let proDevices = state.agroBot.concat(state.agroBotComp);
    // proDevices = proDevices.concat(state.agroBotBasic);

    // function parseHumidity(raw) {
    //   let vwc =
    //     (6.77 * Math.pow(10, -10) * Math.pow(raw, 3) -
    //       5.105 * Math.pow(10, -6) * Math.pow(raw, 2) +
    //       1.302 * Math.pow(10, -2) * raw -
    //       10.848) *
    //     100;
    //   return vwc;
    // }

    // function ecParser(rawHumidity, rawEC, vwc, Tsoil) {
    //   //Parsed Volumetric Water Content
    //   let Om = vwc / 100;

    //   //ELECTRICAL CONDUCTIVITY DESTILLED WATER
    //   let Od = 0;

    //   //USING EXAMPLE 1.5Mg/m3 REAL 1.48
    //   let Pb = 1.5;

    //   //USING EXAMPLE 2.65Mg/m3
    //   let Ps = 2.65;

    //   //Dielectric permittivity
    //   let Ep = 80.3 - 0.37 * Tsoil - 20;

    //   //Segun HILHOST 2000!?
    //   let Eab = 4.1;

    //   //Real portion of the dielectric permittivity of the bulk soil
    //   let Eb = Math.pow(
    //     2.887 * Math.pow(10, -9) * Math.pow(rawHumidity, 3) -
    //     2.08 * Math.pow(10, -5) * Math.pow(rawHumidity, 2) +
    //     5.276 * Math.pow(10, -2) * rawHumidity -
    //     43.39,
    //     2
    //   );

    //   //Pore water conductivity
    //   let Op = (Ep * rawEC) / (Eb - Eab);

    //   let Porosity = 1 - Pb / Ps;

    //   //Saturation extract EC
    //   let solutionEC = (Op * Om + Od) / Porosity;

    //   return solutionEC;
    // }

    // proDevices.forEach(async (Device) => {
    // });
    // console.log("proDevices", proDevices);
    // // commit("proDevices", this.proDevices);

    // return proDevices;
  },
};
